/*
 * item should be of this shape:
 *
 *    isExternal
 *    linkType
 *    linkText
 *    url
 *    entry {
 *      url
 *    }
 */
function getButtonProps(item) {
  let props = {
    label: item.linkText,
  }

  if (item.linkType?.value === "url") {
    if (!item.buttonUrl && !item.url) {
      return false
    }
    props.href = item.buttonUrl || item.url
    props.external = item.buttonIsExternal
  }

  if (item.linkType?.value === "entry") {
    if (!item.entry?.url) {
      return false
    }
    props.to = item.entry?.url
  }

  return props
}

export default getButtonProps
